import React from 'react'

import { Checkbox } from '@wartek-id/checkbox-v1'

interface IPactCheckboxProps {
  checkCopy: string
  checkMark: boolean
  setCheckMark: React.Dispatch<React.SetStateAction<boolean>>
}

const PactCheckbox = ({
  checkCopy,
  checkMark,
  setCheckMark,
}: IPactCheckboxProps) => {
  return (
    <Checkbox
      value="IntegrityPact"
      checked={checkMark}
      onChange={() => setCheckMark(!checkMark)}
      style={{ marginTop: 24 }}
      controlled
      labelPosition="center"
    >
      {checkCopy}
    </Checkbox>
  )
}

export default PactCheckbox
